var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 112C25.6221 112 0.5 86.8779 0.5 56C0.5 25.1221 25.6221 0 56.5 0C87.3779 0 112.5 25.1221 112.5 56C112.5 86.8779 87.3779 112 56.5 112ZM56.5 7C29.4809 7 7.5 28.9809 7.5 56C7.5 83.0191 29.4809 105 56.5 105C83.5191 105 105.5 83.0191 105.5 56C105.5 28.9809 83.5191 7 56.5 7ZM48.4745 75.9745L83.4745 40.9745C84.8421 39.6069 84.8421 37.3923 83.4745 36.0255C82.1069 34.6588 79.8923 34.6579 78.5255 36.0255L46 68.551L34.4745 57.0255C33.1069 55.6579 30.8923 55.6579 29.5255 57.0255C28.1588 58.3931 28.1579 60.6078 29.5255 61.9745L43.5255 75.9745C44.2089 76.6579 45.1049 77 46 77C46.8951 77 47.7911 76.6579 48.4745 75.9745Z",
    fill: "#14B4AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.a4dee94b5387725837de118bb111dac6.svg";
export { ForwardRef as ReactComponent };